/**
 * empty.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component } from "@angular/core";
import { Router } from "@angular/router";

/**
 * {@link EmptyComponent} is a behaviorless, template-less component, mainly
 * for use in development when a component is needed that hasn't been created
 * yet (e.g. for routing or sub-templating).
 */
@Component({
  selector: "empty",
  template: `<!-- empty component -->`
})
export class EmptyComponent
{
  /**
   * Construct a new {@link EmptyComponent}.
   *
   */
  public constructor (router : Router)
  {
    console.info("Constructed empty component");
    // Nothing
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/empty.component.ts